
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexiNtA_znKj_zn_45wsEgsmLpyYSVS7XVZ24_KIDRjqK_10Meta } from "/app/src/pages/index.vue?macro=true";
import { default as loginat_45I4W6dhaKeU4e7R3nRygvy7k1_45w8CiYRML3dJJNP8Meta } from "/app/src/pages/login.vue?macro=true";
import { default as usuarioKCs86X_45ASBhBtUUcfV_45_hZhfKWihBFwAMOypI4q_45erAMeta } from "/app/src/pages/usuario.vue?macro=true";
import { default as _91id_9392ViaeJ7VMwxeOAw4NBsm3ri2S_pXFuyrgqq_45_qzDhEMeta } from "/app/src/pages/curso/[id].vue?macro=true";
import { default as certificadoM2iQN2Km4_wWdb0vFTz0wPdhnVoXGsQKYNSXfi2ntwMMeta } from "/app/src/pages/certificado.vue?macro=true";
import { default as indexitwUl38INxo85NIsIOVf3aTommjKi_YhTdAjrYXjF7gMeta } from "/app/src/pages/curso/index.vue?macro=true";
import { default as categoriafwVPGAJ0yorRfkJzlGMYHQDP_450Ahqe81hi8u8r3zf88Meta } from "/app/src/pages/admin/categoria.vue?macro=true";
import { default as _91id_93LdebfmKGw5ZfnWgSGbgDInw_457Q5V2M09Sz3sFkHQlj4Meta } from "/app/src/pages/admin/curso/[id].vue?macro=true";
import { default as indexLLoUlmp56HJ7EImneaMceYx2uhLgIp0kTOoo_45jv_45AgMMeta } from "/app/src/pages/admin/curso/index.vue?macro=true";
import { default as tipo_45usuario2dSFx8ffpCpkzNhcuYh_45mxLoGVtfzs_JdSlJ38nxEYYMeta } from "/app/src/pages/admin/tipo-usuario.vue?macro=true";
import { default as cadastro99UwdZ532JOpzx1bnlsmJosZ_45Uk8vCckHQ6MDcpnYS8Meta } from "/app/src/pages/admin/curso/cadastro.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexiNtA_znKj_zn_45wsEgsmLpyYSVS7XVZ24_KIDRjqK_10Meta || {},
    component: () => import("/app/src/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginat_45I4W6dhaKeU4e7R3nRygvy7k1_45w8CiYRML3dJJNP8Meta || {},
    component: () => import("/app/src/pages/login.vue")
  },
  {
    name: "usuario",
    path: "/usuario",
    meta: usuarioKCs86X_45ASBhBtUUcfV_45_hZhfKWihBFwAMOypI4q_45erAMeta || {},
    component: () => import("/app/src/pages/usuario.vue")
  },
  {
    name: "curso-id",
    path: "/curso/:id()",
    meta: _91id_9392ViaeJ7VMwxeOAw4NBsm3ri2S_pXFuyrgqq_45_qzDhEMeta || {},
    component: () => import("/app/src/pages/curso/[id].vue")
  },
  {
    name: "certificado",
    path: "/certificado",
    component: () => import("/app/src/pages/certificado.vue")
  },
  {
    name: "curso",
    path: "/curso",
    meta: indexitwUl38INxo85NIsIOVf3aTommjKi_YhTdAjrYXjF7gMeta || {},
    component: () => import("/app/src/pages/curso/index.vue")
  },
  {
    name: "admin-categoria",
    path: "/admin/categoria",
    meta: categoriafwVPGAJ0yorRfkJzlGMYHQDP_450Ahqe81hi8u8r3zf88Meta || {},
    component: () => import("/app/src/pages/admin/categoria.vue")
  },
  {
    name: "admin-curso-id",
    path: "/admin/curso/:id()",
    meta: _91id_93LdebfmKGw5ZfnWgSGbgDInw_457Q5V2M09Sz3sFkHQlj4Meta || {},
    component: () => import("/app/src/pages/admin/curso/[id].vue")
  },
  {
    name: "admin-curso",
    path: "/admin/curso",
    meta: indexLLoUlmp56HJ7EImneaMceYx2uhLgIp0kTOoo_45jv_45AgMMeta || {},
    component: () => import("/app/src/pages/admin/curso/index.vue")
  },
  {
    name: "admin-tipo-usuario",
    path: "/admin/tipo-usuario",
    meta: tipo_45usuario2dSFx8ffpCpkzNhcuYh_45mxLoGVtfzs_JdSlJ38nxEYYMeta || {},
    component: () => import("/app/src/pages/admin/tipo-usuario.vue")
  },
  {
    name: "admin-curso-cadastro",
    path: "/admin/curso/cadastro",
    meta: cadastro99UwdZ532JOpzx1bnlsmJosZ_45Uk8vCckHQ6MDcpnYS8Meta || {},
    component: () => import("/app/src/pages/admin/curso/cadastro.vue")
  }
]